module.exports = __webpack_public_path__ + "static/optimise-ad80a0cc4f5b027aff751ead37f85507.gif";